import Customers       from "../../customer/Customers";
import MailGroups      from "../group/MailGroups";
import MailSendContent from "./MailSendContent";
import MailSendSubject from "./MailSendSubject";

class MailSend {
  constructor(
    private readonly _mailGroups: MailGroups = new MailGroups(),
    private readonly _customers: Customers = new Customers(),
    private readonly _subject: MailSendSubject = new MailSendSubject(),
    private readonly _content: MailSendContent = new MailSendContent(),
  ) {
  }

  get mailGroups() {
    return this._mailGroups;
  }

  get customers() {
    return this._customers;
  }

  get subject() {
    return this._subject;
  }

  get content() {
    return this._content;
  }
}

export default MailSend;
